/**
 *
 */

const setClubObject = (club) => {
  localStorage.setItem("club", JSON.stringify(club));
};

const getClubObject = () => {
  const club = localStorage.getItem("club");
  return club ? JSON.parse(club) : null;
};

const setIsDefault = (isDefault) => {
  localStorage.setItem("isDefault", JSON.stringify(isDefault));
};

const getIsDefault = () => {
  const isDefault = localStorage.getItem("isDefault");
  return isDefault ? JSON.parse(isDefault) : true;
};

const setTokenTCAndExpireToken = (token, expTokenTC, sesion) => {
  localStorage.setItem("tokenTC", token);

  const exp = expTokenTC || Date.now() + 1800000; //+ 30min
  localStorage.setItem("expTokenTC", exp);

  localStorage.setItem("sesion", JSON.stringify(sesion));
};

const getTokenTC = () => {
  const tokenTC = localStorage.getItem("tokenTC");
  return tokenTC || null;
};

const getSesion = () => {
  const sesion = localStorage.getItem("sesion");
  return sesion ? JSON.parse(sesion) : null;
};

const checkExpTokenTC = () => {
  const expTokenTC = localStorage.getItem("expTokenTC");
  const now = Date.now();
  return !expTokenTC || parseInt(expTokenTC) < now ? false : true;
};

const setMemberObject = (member) => {
  localStorage.setItem("member", JSON.stringify(member));
};

const getMemberObject = () => {
  const member = localStorage.getItem("member");
  return member ? JSON.parse(member) : null;
};

const setSearchWeekObject = (searchWeek) => {
  localStorage.setItem("searchWeek", JSON.stringify(searchWeek));
};

const getSearchWeekObject = (query = {}) => {
  const searchWeek = localStorage.getItem("searchWeek");
  const stored = searchWeek ? JSON.parse(searchWeek) : null;

  const checkIn = query.checkIn;
  const checkOut = query.checkOut;
  const city = query.city;
  const country = query.country;
  const state = query.state;

  if (checkIn && checkOut && city && country) {
    const resolved = {
      country,
      state: state || null,
      city,
      checkIn,
      checkOut,
      page: query.page ? parseInt(query.page, 10) : 1,
      limit: query.limit ? parseInt(query.limit, 10) : 10,
    };
    // Filtros de un link compartido (utils/compartir.js); los arreglos llegan como JSON
    for (const campo of FILTROS_EN_URL) {
      const valor = leerFiltroDeUrl(query[campo]);
      if (valor !== null) resolved[campo] = valor;
    }
    setSearchWeekObject(resolved);
    return resolved;
  }

  return stored;
};

const FILTROS_EN_URL = ["type", "capacity", "occupancy", "kitchen", "holiday", "resort", "cityFilter", "priceMin", "priceMax", "rating"];

const leerFiltroDeUrl = (valor) => {
  if (valor === undefined || valor === null || valor === "") return null;
  if (typeof valor === "string" && valor.startsWith("[")) {
    try {
      const arreglo = JSON.parse(valor);
      return Array.isArray(arreglo) && arreglo.length ? arreglo : null;
    } catch (error) {
      // Arreglo mal formado: se ignora ese filtro y la búsqueda sigue
      return null;
    }
  }
  return valor;
};

const setWeekObject = (week) => {
  localStorage.setItem("week", JSON.stringify(week));
};

const getWeekObject = () => {
  const week = localStorage.getItem("week");
  return week ? JSON.parse(week) : null;
};

const setSortWeeksObject = (sortWeeks) => {
  localStorage.setItem("sortWeeks", JSON.stringify(sortWeeks));
};

const getSortWeeksObject = () => {
  const sortWeeks = localStorage.getItem("sortWeeks");
  return sortWeeks ? JSON.parse(sortWeeks) : null;
};

const setBookingTimer = (deadlineTs) => {
  localStorage.setItem("bookingTimerDeadline", String(deadlineTs));
};

const getBookingTimer = () => {
  const t = localStorage.getItem("bookingTimerDeadline");
  return t ? parseInt(t, 10) : null;
};

const removeBookingTimer = () => {
  localStorage.removeItem("bookingTimerDeadline");
};

const setSelectedUnit = (unit) => {
  localStorage.setItem("selectedUnit", JSON.stringify(unit));
};

const getSelectedUnit = () => {
  const u = localStorage.getItem("selectedUnit");
  return u ? JSON.parse(u) : null;
};

const removeSelectedUnit = () => {
  localStorage.removeItem("selectedUnit");
};

const setHoldNumberRef = (numberRef) => {
  localStorage.setItem("holdNumberRef", numberRef);
};

const getHoldNumberRef = () => {
  return localStorage.getItem("holdNumberRef");
};

const removeHoldNumberRef = () => {
  localStorage.removeItem("holdNumberRef");
};

const setTravelerData = (traveler) => {
  localStorage.setItem("bookingTraveler", JSON.stringify(traveler));
};

const getTravelerData = () => {
  const t = localStorage.getItem("bookingTraveler");
  return t ? JSON.parse(t) : null;
};

const removeTravelerData = () => {
  localStorage.removeItem("bookingTraveler");
};

const removeAll = () => {
  localStorage.removeItem("club");
  localStorage.removeItem("isDefault");
  localStorage.removeItem("tokenTC");
  localStorage.removeItem("expTokenTC");
  localStorage.removeItem("sesion");
  localStorage.removeItem("member");
  localStorage.removeItem("searchWeek");
  localStorage.removeItem("week");
  localStorage.removeItem("sortWeeks");
  localStorage.removeItem("bookingTimerDeadline");
  localStorage.removeItem("selectedUnit");
  localStorage.removeItem("holdNumberRef");
  localStorage.removeItem("bookingTraveler");
};

module.exports = {
  setClubObject,
  getClubObject,
  setIsDefault,
  getIsDefault,
  setTokenTCAndExpireToken,
  getTokenTC,
  checkExpTokenTC,
  setMemberObject,
  getMemberObject,
  setSearchWeekObject,
  getSearchWeekObject,
  setWeekObject,
  getWeekObject,
  setSortWeeksObject,
  getSortWeeksObject,
  getSesion,
  setBookingTimer,
  getBookingTimer,
  removeBookingTimer,
  setSelectedUnit,
  getSelectedUnit,
  removeSelectedUnit,
  setHoldNumberRef,
  getHoldNumberRef,
  removeHoldNumberRef,
  setTravelerData,
  getTravelerData,
  removeTravelerData,
  removeAll,
};
